import { PopConfirm } from './Default';
import { StrictPopConfirm } from './StrictPopConfirm';

export default PopConfirm;
export { PopConfirm, StrictPopConfirm };
